import { Assets, Spritesheet, Texture } from 'pixi.js'

// 倍數幣貼圖 — 由 scripts/gen-atlas.mjs 合成的 spritesheet（public/atlas/multipliers.webp + .json）取得。
// frame key 為 X<倍數>（X1、X2…X15）。
const ATLAS = `${import.meta.env.BASE_URL}atlas/multipliers.json`

export const MULTIPLIER_VALUES = [1, 2, 3, 5, 10, 15] as const

const textures = new Map<number, Texture>()

export async function loadMultiplierTextures(): Promise<void> {
  const sheet = await Assets.load<Spritesheet>(ATLAS)
  MULTIPLIER_VALUES.forEach((value) => {
    const tex = sheet.textures[`X${value}`]
    if (tex) textures.set(value, tex)
  })
}

export function multiplierTexture(value: number): Texture | null {
  return textures.get(value) ?? null
}
